import { render, staticRenderFns } from "./buyYxAd.vue?vue&type=template&id=2f2ff27c&"
import script from "./buyYxAd.vue?vue&type=script&lang=js&"
export * from "./buyYxAd.vue?vue&type=script&lang=js&"
import style0 from "./buyYxAd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports